import type { Feature } from '@luna/gatekeeper';

export const cardActivationFlowV2: Feature = {
    enabled: false,
    _description: 'Enables the new card activation flow with progress meter',
};
